<section
    *ngIf="loading"
    class="doc-arc-loading"
    [class.doc-arc-loading--mobile]="'mobile' | mediaQuery"
    [style.--doc-arc-bottom-sheet-height]="bottomSheetMinHeight"
    aria-busy="true"
    aria-label="Loading document"
>
    <div class="doc-arc-loading__viewer" aria-hidden="true">
        <div class="doc-arc-loading__toolbar">
            <span class="tt-skeleton"></span>
            <span class="tt-skeleton"></span>
            <span class="tt-skeleton"></span>
        </div>
        <div class="doc-arc-loading__canvas"></div>
    </div>

    <aside
        class="doc-arc-loading__information"
        [class.doc-arc-loading__information--bottom-sheet]="'mobile' | mediaQuery"
        aria-hidden="true"
    >
        <span *ngIf="'mobile' | mediaQuery" class="doc-arc-loading__handle"></span>
        <span class="tt-skeleton doc-arc-loading__information-heading"></span>
        <span *ngFor="let row of informationSkeletonRows" class="doc-arc-loading__field">
            <span class="tt-skeleton doc-arc-loading__label"></span>
            <span class="tt-skeleton doc-arc-loading__input"></span>
        </span>
        <span class="doc-arc-loading__actions">
            <span class="tt-skeleton"></span>
            <span class="tt-skeleton"></span>
        </span>
    </aside>
</section>

<tt-side-drawer-container *ngIf="!!page" [class.doc-arc--mobile]="'mobile' | mediaQuery" [style.--doc-arc-bottom-sheet-height]="bottomSheetMinHeight">
    <tt-toast *ngIf="fileError" ttType="danger" ttTitle="Error" ttTranslateTitle="false" [ttMessage]="fileError" ttTranslateMessage="false"></tt-toast>
    <tt-document-viewer *ngIf="!fileError" [file]="('mobile' | mediaQuery) ? mobileViewerPage : page" (officeConversionCompleted)="onOfficeConversionCompleted($event)"></tt-document-viewer>

    <ng-container *ngIf="!('mobile' | mediaQuery)">
        <tt-button class="drawer-toggle" ttText="h_info" (ttClick)="drawer.toggle()"></tt-button>
        <tt-side-drawer #drawer ttRememberId="w_docarc.infodrawer" ttPersistLocalOnly="false" ttInitialState="open" ttDisableClose ttPosition="end" ttWidth="30rem" ttMode="side">
            <tt-doc-arc-information [page]="page" [documentCategories]="documentCategories"></tt-doc-arc-information>
        </tt-side-drawer>
    </ng-container>

    <tt-bottom-sheet *ngIf="'mobile' | mediaQuery" [ttMinHeight]="bottomSheetMinHeight">
        <tt-doc-arc-information [page]="page" [documentCategories]="documentCategories"></tt-doc-arc-information>
    </tt-bottom-sheet>
</tt-side-drawer-container>
